import {
  initialState,
  Actions,
  State,
  GET_ONE_USER,
  GET_ONE_USER_SUCCESS,
  GET_ONE_USER_ERROR,
  RESET_GET_ONE_USER,
} from '../../types/user/get-one'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ONE_USER:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case GET_ONE_USER_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case GET_ONE_USER_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      }
    case RESET_GET_ONE_USER:
      return initialState
    default:
      return state
  }
}

export default reducers
